import {xlsApiList} from '@/plugin/enum'

export default {
    methods: {
        handleReset(name) { // 清空表单
            this.$refs[name].resetFields()
        },
        handleFile(target, data) { // 打印
            window.location.href = window.location.origin + `/api/${xlsApiList[target]}?` + this.urlencoded(data)
        },
        urlencoded(data) {
            data.date && delete data.date
            let result = []
            for (let item in data) {
                // 去除数据中的undefined 和 空格
                if (data[item] && data[item] !== 'undefined') {
                    let value = data[item].toString()
                    result.push(`${item}=${encodeURIComponent(value)}`)
                }
            }
            return result.join('&')
        },
        goToPage(url, data) { // 页面跳转
            let routeUrl = this.$router.resolve({
                path: `/expenses/${url}`,
                query: data
            })
            window.open(routeUrl.href, '_blank')
        },
        updatePage(url) {
            this.$router.push({
                path: `/expenses/${url}`
            })
        },
        goToPagePath(url, data) { // 页面跳转
            let routeUrl = this.$router.resolve({
                path: url,
                query: data
            })
            window.open(routeUrl.href, '_blank')
        },
        updatePagePath(url) {
            this.$router.push({
                path: url
            })
        },
        showLoading(hint){
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                size: 18
                            }
                        }),
                        h('div', hint)
                    ])
                }
            });
        },
        hideLoading(){
            this.$Spin.hide();
        }

    }
}
